import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenNib,
  faLaptopCode,
  faMagnifyingGlass,
  faRocket,
  faShareNodes,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: "ui-ux-design",
      icon: faPenNib,
      title: "Website Design & UI/UX",
      desc:
        "We craft clean, purposeful interfaces that make a strong first impression, communicate trust instantly, and guide visitors toward action.",
    },
    {
      id: "web-development",
      icon: faLaptopCode,
      title: "Web & App Development",
      desc:
        "Fast, reliable, and scalable — we build websites and web apps that perform consistently across every device and screen size.",
    },
    {
      id: "search-engine-optimization",
      icon: faMagnifyingGlass,
      title: "SEO & Organic Visibility",
      desc:
        "We strengthen your site's technical foundations and content structure so the right people can discover you through search.",
    },
    {
      id: "social-media-marketing",
      icon: faShareNodes,
      title: "Social Media Management",
      desc:
        "Consistent, strategic content that builds your brand presence, keeps your audience engaged, and drives real-world enquiries.",
    },
    {
      id: "search-engine-marketing",
      icon: faRocket,
      title: "Paid Ads & Lead Generation",
      desc:
        "Focused ad campaigns built around your ideal customer — tested, refined, and optimised to deliver measurable returns.",
    },
    {
      id: "local-business-growth",
      icon: faLocationDot,
      title: "Local Business Growth",
      desc:
        "We optimise your local digital presence so nearby customers can find you easily, trust you quickly, and reach out confidently.",
    },
  ];

  return (
    <section className="about-services" aria-label="Our services">
      <div className="about-services-wrap">
        {/* Header */}
        <header className="about-services-head">
          <h2>Our core services</h2>
          <p>
            Every service we offer is built around one goal — making your online
            presence work harder and smarter for your business.
          </p>
        </header>

        {/* Services list */}
        <div className="about-services-list">
          {services.map((s) => (
            <article
              key={s.id}
              className="about-services-item"
              onClick={() => navigate(`/services/${s.id}`)}
              tabIndex={0}
              role="button"
            >
              <div className="about-services-icon">
                <FontAwesomeIcon icon={s.icon} />
              </div>

              <div className="about-services-content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
